import { observable, action, computed } from "mobx";
import { findIndex } from "lodash";
import { ConsultantEditorStore } from "../../ConsultantEditorStore";
import {
  ExpertiseProfession,
  ExpertiseProfessionStore
} from "../ExpertiseProfessionStore";

export interface SocionomProfession extends ExpertiseProfession {
  areasOfExpertise: AreaOfExpertise[];
  educations?: string[];
}

export interface AreaOfExpertise {
  name: string;
  qualified: boolean;
  interested: boolean;
  comment: string;
  yearFrom: string;
  open: boolean;
  specializations: Specialization[];
}

export interface Specialization {
  name: string;
  qualified: boolean;
  interested: boolean;
  comment: string;
}

export class SocionomStore extends ExpertiseProfessionStore<SocionomProfession> {
  @observable selectedAoE: string[];

  constructor(
    profession: string,
    storeIndex: number,
    public editorStore: ConsultantEditorStore
  ) {
    super(profession, storeIndex, editorStore);
    this.selectedAoE = null;
  }

  get areasOfExpertise(): AreaOfExpertise[] {
    return this.currentExpertiseProfession.areasOfExpertise;
  }

  get errorAoe() {
    return this.editorStore.form.getError(
      `expertise.${this.storeIndex}.areasOfExpertise`
    );
  }

  get selectAoEList() {
    return this.editorStore
      .getAOEsOnProfession(this.profession)
      .filter((x) => x !== "Socionom")
      .filter((x) => !this.areasOfExpertise?.any((y) => y.name === x));
  }

  get educations(): string[] {
    return this.editorStore.getEducationsOnProfession(this.profession);
  }

  @computed get selectedEducations(): string[] {
    return this.currentExpertiseProfession?.educations || [];
  }

  @action addEducations = (items: string[]) => {
    this.editorStore.form.setValue(`professions.${this.storeIndex}.educations`, items);
  };

  @action setSelectedAoE = (val: string[]) => {
    this.selectedAoE = val;
  };

  @action addAoE = () => {
    this.selectedAoE.map((x) => {
      const i = findIndex(this.areasOfExpertise, (a) => a.name === x);
      if (i === -1) {
        this.editorStore.form.push(`professions.${this.storeIndex}.areasOfExpertise`, {
          name: x,
          qualified: true,
          interested: true,
          comment: "",
          yearFrom: "",
          open: true,
          specializations: this.editorStore
            .getSpecialization(x, this.profession)
            .map((y) => ({
              name: y,
              qualified: false,
              interested: false,
              comment: ""
            }))
        });
      }
    });
    this.setSelectedAoE(null);
  };

  @action removeAOEByIndex = (i: number) => {
    this.editorStore.form.removeByIndex(
      `professions.${this.storeIndex}.areasOfExpertise`,
      i
    );
  };

  @action toggleAOEByIndex = (i: number) => {
    this.areasOfExpertise[i].open = !this.areasOfExpertise[i].open;
    this.editorStore.form.setValue(
      `professions.${this.storeIndex}.areasOfExpertise`,
      this.areasOfExpertise
    );
  };

  initForm() {
    if (!this.currentExpertiseProfession) {
      this.editorStore.form.setValue(`professions.${this.storeIndex}`, {
        professionName: this.profession,
        areasOfExpertise: [],
        educations: []
      });
    }
  }
}
